import { render, staticRenderFns } from "./drupal-ou-wordpress.vue?vue&type=template&id=1d506b2c&"
import script from "./drupal-ou-wordpress.vue?vue&type=script&lang=js&"
export * from "./drupal-ou-wordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports